<script lang="ts">
  import { Image } from "sveltestrap";
  import { href } from "../../../../utils/Constant/Constant";
  import Link from "svelte-link";
  let imgPath:string = "/assets/images/user"
  export let image:string
  export let hours:number
  
</script>
<div class="post-header">
    <div class="media">
        <Image class="img-thumbnail rounded-circle me-3" src="{imgPath}/{image}" alt="Generic placeholder image" />
        <div class="media-body align-self-center">
            <Link href={href}>
                <h5 class="user-name">{'Emay Walter'}</h5>
            </Link>
            <h6>{hours} {'Hours ago'}</h6>
        </div>
    </div>
    <div class="post-setting">
        <i class="fa fa-ellipsis-h"></i>
    </div>
</div>
